<!--
 * @Author: your name
 * @Date: 2021-11-11 12:50:34
 * @LastEditTime: 2022-05-26 17:34:45
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\views\home.vue
-->
<template>
    <div class="container" style="height: 100%;">
        <div class="nav-bg-bar" :style="getBootstrap.navBgBar">
            <img class="nav-bg-img" :style="getBootstrap.navBgImg" src="@/assets/images/sucai/nav-bg.png" alt="">
            <div class="system-logo">
                <div class="shine-feel">
                    <img class="logo-img" src="@/assets/images/logo.png" alt="">
                </div>
            </div>
            <div class="system-title">
                <img class="title-img" src="@/assets/images/sucai/system-title.png" alt="">
            </div>
        </div>
        <div class="content">
            <van-grid :column-num="2" :gutter="22" offse :border="false">
                <van-grid-item v-for="(item, key) in gridItems" :key="key" :text="item.title" @click="nextTo(item.name)" class="jelly-feel">
                    <template #icon>
                        <img :src="item.icon" :alt="item.title" class="block-icon" />
                    </template>
                </van-grid-item>
            </van-grid>
        </div>
        <mini-dialog v-model="show" :showConfirmButton="false" @close="close">
            <div slot="title">敬请期待</div>
            <div slot="icon"><img src="@/assets/images/empty/not-success.png" style="width: 196px;height: 128px;" /></div>
            <div slot="desc">更多内容敬请期待</div>
        </mini-dialog>
    </div>
</template>
<script>
import MiniDialog from '@/components-busi/mini-dialog/index.vue'
export default {
    components: {
        "mini-dialog": MiniDialog,
    },
    data() {
        return {
            gridItems: [
                { icon: require("@/assets/images/sucai/block-1.png"), title: "经销商档案", name: 'dealer-archives' },
                { icon: require("@/assets/images/sucai/block-2.png"), title: "经销商评估", name: 'dealer-assess-catalogue' },
               { icon: require("@/assets/images/sucai/block-3.png"), title: "经销商满意度调查", name: 'satisfaction-list' },
                { icon: require("@/assets/images/sucai/block-4.png"), title: "学习管理", name: 'lesson-type' },
                { icon: require("@/assets/images/sucai/block-5.png"), title: "经销商工具", name: 'dealer-tools' },
                { icon: require("@/assets/images/sucai/block-6.png"), title: "更多应用", name: '' },
            ],
            show: false,
        }
    },
    created() {
    },
    mounted() {
        // let userInfo = this.$store.state.user.userInfo
        // if(userInfo) {
        //     let phoneSuffix = this.$utils.common.getPhoneSuffix(userInfo.phone)
        //     let txt = `PepsiCo-${userInfo.realName}-${phoneSuffix}`
        //     this.$utils.Watermark.create(txt)
        // }
        localStorage.removeItem('link')
    },
    computed: {
        getBootstrap() {
            if(this.getOpenInWechat) {
                return { navBgImg: 'top: -88px;'}
            }else{
                return { navBgImg: 'top: -44px;'}
            }
        },
        getOpenInWechat() {
            return this.$store.state.app.system.openInWechat
        },
    },
    methods: {
        nextTo(name) {
            // setTimeout(() => {
                if(!name) {
                    this.showLoginFailDialog()
                    return
                }
                this.$router.push({
                    name: name
                })
            // }, 50);
        },
        showLoginFailDialog() {
            this.show = true
        },
        hideLoginFailDialog() {
            this.show = false
        },
        close() {
            this.hideLoginFailDialog()
        }
    }
}
</script>
<style lang="less" scoped>
    @import './index.less';
</style>